import { FC } from 'react';

import ProductIdentifier from '@ingka/product-identifier';
import { getLocaleSetting } from '@onlinepayments/payments-library';
import * as Sentry from '@sentry/browser';

import { OrderItem } from '../../interfaces/Order';
import { formatArticleNo } from '../../utils/immutability-utils';

import OrderListItemImage from './OrderListItemImage';

interface IOrderLineListItemProps {
  item: OrderItem;
}

const OrderLineListItem: FC<IOrderLineListItemProps> = ({
  item: { salesItem: item, orderLine },
}) => {
  const {
    itemKey: { itemNo },
    localisedCommunications,
  } = item;
  const { quantity } = orderLine;

  if (!localisedCommunications?.length) {
    Sentry.captureMessage(`Missing localisedCommunications for sales item ${itemNo}.`, 'error');

    return null;
  }

  const [{ productName, measurements, productType, validDesign }] = localisedCommunications;

  return (
    <li className="OrderLineListItem flex my-100" key={itemNo}>
      <OrderListItemImage item={item} />

      <div className="flex direction-column">
        <strong>
          {quantity}x {productName}
        </strong>
        <ProductIdentifier value={formatArticleNo(itemNo)} />
        {getLocaleSetting().payment.showProductDetails && (
          <>
            <span>{productType?.name}</span>
            <span>{validDesign?.text}</span>
            <span>{measurements?.referenceMeasurements?.[0]?.metric}</span>
          </>
        )}
      </div>
    </li>
  );
};

export default OrderLineListItem;
